import { AppRoutes } from "../routes/routeConstants/appRoutes";

/** Subset of location stored when sending unauthenticated users to login. */
export type StoredRedirectLocation = {
  pathname: string;
  search?: string;
};

/**
 * Returns a safe in-app path to open after login, or `fallback` if none / invalid / auth routes
 * (prevents open redirects).
 */
export function resolvePostLoginPath(
  from: StoredRedirectLocation | undefined | null,
  fallback: string = AppRoutes.HOME
): string {
  if (!from || typeof from.pathname !== "string") return fallback;
  const { pathname, search = "" } = from;
  if (!pathname.startsWith("/") || pathname.startsWith("//")) return fallback;
  if (
    pathname === AppRoutes.LOGIN ||
    pathname === AppRoutes.AUTH ||
    pathname.startsWith(`${AppRoutes.AUTH}/`)
  ) {
    return fallback;
  }
  return `${pathname}${search}`;
}

/** Decode `?returnUrl=` from the login page (survives refresh; must match `resolvePostLoginPath` rules). */
export function storedLocationFromReturnUrlParam(
  encoded: string | null | undefined
): StoredRedirectLocation | undefined {
  if (encoded == null || encoded === "") return undefined;
  try {
    const full = decodeURIComponent(encoded);
    if (!full.startsWith("/") || full.startsWith("//")) return undefined;
    const q = full.indexOf("?");
    if (q === -1) return { pathname: full };
    const pathname = full.slice(0, q) || "/";
    const search = full.slice(q);
    return { pathname, search };
  } catch {
    return undefined;
  }
}
